import request from '../../axios';

export const deleteLoanRequest = async (loanGuid: string) => {
  return await request.delete(
    `/api/v2/payment/delete-loan-request/loan-request/${loanGuid}`,
  );
};
